// Search Constants for API calls

// Item ID Search Constants
export const SEARCH_ITEM_ID_REQUEST = 'SEARCH_ITEM_ID_REQUEST'
export const SEARCH_ITEM_ID_SUCCESS = 'SEARCH_ITEM_ID_SUCCESS'
export const SEARCH_ITEM_ID_FAILURE = 'SEARCH_ITEM_ID_FAILURE'
export const SEARCH_ITEM_ID_RESET = 'SEARCH_ITEM_ID_RESET'

// Description Match Search Constants
export const SEARCH_DESCRIPTION_MATCH_REQUEST = 'SEARCH_DESCRIPTION_MATCH_REQUEST'
export const SEARCH_DESCRIPTION_MATCH_SUCCESS = 'SEARCH_DESCRIPTION_MATCH_SUCCESS'
export const SEARCH_DESCRIPTION_MATCH_FAILURE = 'SEARCH_DESCRIPTION_MATCH_FAILURE'
export const SEARCH_DESCRIPTION_MATCH_RESET = 'SEARCH_DESCRIPTION_MATCH_RESET'

// Product Class (Class4) Search Constants
export const SEARCH_PRODUCT_CLASS_REQUEST = 'SEARCH_PRODUCT_CLASS_REQUEST'
export const SEARCH_PRODUCT_CLASS_SUCCESS = 'SEARCH_PRODUCT_CLASS_SUCCESS'
export const SEARCH_PRODUCT_CLASS_FAILURE = 'SEARCH_PRODUCT_CLASS_FAILURE'
export const SEARCH_PRODUCT_CLASS_RESET = 'SEARCH_PRODUCT_CLASS_RESET'

// Sales Discount Group Search Constants
export const SEARCH_PRODUCT_DISCOUNT_GROUP_REQUEST = 'SEARCH_PRODUCT_DISCOUNT_GROUP_REQUEST'
export const SEARCH_PRODUCT_DISCOUNT_GROUP_SUCCESS = 'SEARCH_PRODUCT_DISCOUNT_GROUP_SUCCESS'
export const SEARCH_PRODUCT_DISCOUNT_GROUP_FAILURE = 'SEARCH_PRODUCT_DISCOUNT_GROUP_FAILURE'
export const SEARCH_PRODUCT_DISCOUNT_GROUP_RESET = 'SEARCH_PRODUCT_DISCOUNT_GROUP_RESET'

// Product Group Search Constants
export const SEARCH_PRODUCT_GROUP_REQUEST = 'SEARCH_PRODUCT_GROUP_REQUEST'
export const SEARCH_PRODUCT_GROUP_SUCCESS = 'SEARCH_PRODUCT_GROUP_SUCCESS'
export const SEARCH_PRODUCT_GROUP_FAILURE = 'SEARCH_PRODUCT_GROUP_FAILURE'
export const SEARCH_PRODUCT_GROUP_RESET = 'SEARCH_PRODUCT_GROUP_RESET'

// Mfg pricing Search Constants
export const SEARCH_MFG_PRICING_GROUP_REQUEST = 'SEARCH_MFG_PRICING_GROUP_REQUEST'
export const SEARCH_MFG_PRICING_GROUP_SUCCESS = 'SEARCH_MFG_PRICING_GROUP_SUCCESS'
export const SEARCH_MFG_PRICING_GROUP_FAILURE = 'SEARCH_MFG_PRICING_GROUP_FAILURE'
export const SEARCH_MFG_PRICING_GROUP_RESET = 'SEARCH_MFG_PRICING_GROUP_RESET'

// UOM Search Constants
export const SEARCH_UOM_REQUEST = 'SEARCH_UOM_REQUEST'
export const SEARCH_UOM_SUCCESS = 'SEARCH_UOM_SUCCESS'
export const SEARCH_UOM_FAILURE = 'SEARCH_UOM_FAILURE'
export const SEARCH_UOM_RESET = 'SEARCH_UOM_RESET'

// Supplier Search Constants
export const SEARCH_SUPPLIER_REQUEST = 'SEARCH_SUPPLIER_REQUEST'
export const SEARCH_SUPPLIER_SUCCESS = 'SEARCH_SUPPLIER_SUCCESS'
export const SEARCH_SUPPLIER_FAILURE = 'SEARCH_SUPPLIER_FAILURE'
export const SEARCH_SUPPLIER_RESET = 'SEARCH_SUPPLIER_RESET'

// Add Product to ERP Constants
export const ADD_PRODUCT_TO_ERP_REQUEST = 'ADD_PRODUCT_TO_ERP_REQUEST'
export const ADD_PRODUCT_TO_ERP_SUCCESS = 'ADD_PRODUCT_TO_ERP_SUCCESS'
export const ADD_PRODUCT_TO_ERP_FAILURE = 'ADD_PRODUCT_TO_ERP_FAILURE'

// Price File Search Constants (mock-backed)
export const SEARCH_PRICE_FILE_REQUEST = 'SEARCH_PRICE_FILE_REQUEST'
export const SEARCH_PRICE_FILE_SUCCESS = 'SEARCH_PRICE_FILE_SUCCESS'
export const SEARCH_PRICE_FILE_FAILURE = 'SEARCH_PRICE_FILE_FAILURE'
export const SEARCH_PRICE_FILE_RESET = 'SEARCH_PRICE_FILE_RESET'

// Price File Browser (full table, one file at a time)
export const BROWSE_PRICE_FILE_REQUEST = 'BROWSE_PRICE_FILE_REQUEST'
export const BROWSE_PRICE_FILE_SUCCESS = 'BROWSE_PRICE_FILE_SUCCESS'
export const BROWSE_PRICE_FILE_FAILURE = 'BROWSE_PRICE_FILE_FAILURE'
export const BROWSE_PRICE_FILE_RESET = 'BROWSE_PRICE_FILE_RESET'

// Vendor Portal Search Constants (long-running mock)
export const SEARCH_VENDOR_PORTAL_REQUEST = 'SEARCH_VENDOR_PORTAL_REQUEST'
export const SEARCH_VENDOR_PORTAL_SUCCESS = 'SEARCH_VENDOR_PORTAL_SUCCESS'
export const SEARCH_VENDOR_PORTAL_FAILURE = 'SEARCH_VENDOR_PORTAL_FAILURE'
export const SEARCH_VENDOR_PORTAL_CANCEL = 'SEARCH_VENDOR_PORTAL_CANCEL'
export const SEARCH_VENDOR_PORTAL_RESET = 'SEARCH_VENDOR_PORTAL_RESET'

// Vendor Site Search Constants
export const SEARCH_VENDOR_SITE_REQUEST = 'SEARCH_VENDOR_SITE_REQUEST'
export const SEARCH_VENDOR_SITE_SUCCESS = 'SEARCH_VENDOR_SITE_SUCCESS'
export const SEARCH_VENDOR_SITE_FAILURE = 'SEARCH_VENDOR_SITE_FAILURE'
export const SEARCH_VENDOR_SITE_RESET = 'SEARCH_VENDOR_SITE_RESET'
